// backport from newsletterController.js and merged with fork from RBMC
import urlService from '../services/rbata.urlService';
import personalizeService from '../services/rbata.personalizeService';
import gigyaLiteRegistration from '../gigya/rbata.lite-registration';

const footer = {
    settingsLink: personalizeService.getEncodedContextPath() + '/settings/',
    bindHandler() {
        $('#js-page-footer__submit').on('click', (evt) => {
            evt.preventDefault();
            const value   = $(evt.currentTarget).prev().val();

            if (value === '') {
                return;
            }

            const subscriptionStatus = gigyaLiteRegistration.fetchSubscriptionData(value);

            subscriptionStatus.done((response) => {
                if (!response.allowSubscription) {
                    gigyaLiteRegistration.alreadySubscribedActions(response, value);
                } else {
                    window.location.href = `${urlService.getBaseUrl()}newsletter/register/?email=${encodeURIComponent(value)}`;
                }
            });
        });
    },
    buildSettings() {
        $('.page-footer__settings-link').each((index, element) => {
            element.href = this.settingsLink;
        });
        $('#js-page-footer__language').html(`${personalizeService.getLanguageName()}&nbsp;(${personalizeService.getCurrency()})`);
    },
};

$(() => {
    if ($('.page-footer').length) {
        footer.bindHandler();
        footer.buildSettings();
    }
});

export default footer;
